<div *ngIf="initialized">
  <div class="card">
    <div>
      <header class="card-header bg-light py-3 px-5">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="mb-0">Category Details</h5>
          <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </header>
      <div class="card-body">
        <div class="cs_container">
          <div class="cs_popover-body">
            <div class="cs_grid col-1-2">
              <div class="cs_col">
                <div class="cs_img-container">
                  <img src="../../../../assets/img/assessment/{{getCategoryImage()}}" alt="" />
                  <h3>{{category | enumString: impairmentCategoryEnum }}</h3>
                </div>
              </div>
              <div class="cs_col">
                <h3>About the Categories:</h3>
                <p class="cs_text-justify">
                  While there is no perfect way to run, we have found that
                  there are common imperfect patterns. The RunDNA
                  Categories highlight these patterns to help you spot
                  areas for improvement and take clear steps toward better
                  running.
                </p>
              </div>
            </div>

            <h3>Personalized Feedback:</h3>
            <p class="cs_text-justify">
              {{getCategoryDescription()}}
            </p>

            <h3 *ngIf="category != impairmentCategory.PerformanceOptimization">Key Indicators:</h3>

            <!-- OVERSTRIDER -->
            <div *ngIf="category == impairmentCategory.OverstriderGeneral" class="cs_grid cs_mb-md cs_gap-md">
              <div class="cs_details-tile">
                <h5>Strike from Center of Mass</h5>
                <div class="cs_details-wrapper">
                  <div class="cs_details-img">
                    <img src="../../../../assets/img/assessment/strike-from-com-icon.png"
                         alt="" />
                  </div>
                  <div class="cs_details-content">
                    <div class="cs_details-item">R {{removeNegtiveSign(analysis.scom.rightValue)| number:'1.0-0'}} cm</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.scom.rightScore | enumString: categoryScoreEnum | lowercase }}">{{ overrideScore(analysis.scom.rightScore | enumString: categoryScoreEnum )}}</div>
                    </div>
                    <div class="cs_details-item">L {{removeNegtiveSign(analysis.scom.leftValue)| number:'1.0-0'}} cm</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.scom.leftScore | enumString: categoryScoreEnum | lowercase }}">{{ overrideScore(analysis.scom.leftScore | enumString: categoryScoreEnum )}}</div>
                    </div>
                  </div>
                </div>
                <h6>Distance between foot strike and your body's center of mass</h6>
              </div>

              <div class="cs_details-tile">
                <h5>Tibial Inclination</h5>
                <div class="cs_details-wrapper">
                  <div class="cs_details-img">
                    <img src="../../../../assets/img/assessment/yibial-inclination-icon.png"
                         alt="" />
                  </div>
                  <div class="cs_details-content">
                    <div class="cs_details-item">R {{removeNegtiveSign(analysis.icTibialInclination.rightValue)| number:'1.0-0'}}° {{getLabelTibialInclination(analysis.icTibialInclination.rightValue)}}</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.icTibialInclination.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore( analysis.icTibialInclination.rightScore | enumString: categoryScoreEnum )}}</div>
                    </div>
                    <div class="cs_details-item">L {{removeNegtiveSign(analysis.icTibialInclination.leftValue)| number:'1.0-0'}}° {{getLabelTibialInclination(analysis.icTibialInclination.leftValue)}}</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.icTibialInclination.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore( analysis.icTibialInclination.leftScore | enumString: categoryScoreEnum) }}</div>
                    </div>
                  </div>
                </div>
                <h6>Angle of your shin at the moment of foot strike</h6>
              </div>
            </div>


            <!-- CADENCE -->
            <div *ngIf="category == impairmentCategory.GeneralCadence" class="cs_grid cs_mb-md cs_gap-md">
              <div class="cs_details-tile">
                <h5>Cadence</h5>
                <div class="cs_details-wrapper single-in-row">
                  <div class="cs_details-img">
                    <img src="../../../../assets/img/assessment/cadence-icon.png"
                         alt="" />
                  </div>
                  <div class="cs_details-content">
                    <div class="cs_details-item">{{analysis.cadence.value | number:'1.0-0'}} spm</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.cadence.score | enumString: categoryScoreEnum | lowercase }}">{{overrideScore( analysis.cadence.score | enumString: categoryScoreEnum) }}</div>
                    </div>
                    <div class="cs_details-item"></div>
                  </div>
                </div>
                <h6>Number of steps per minute while running</h6>
              </div>
            </div>

            <!-- BOUNCER -->
            <div *ngIf="category == impairmentCategory.Bouncer" class="cs_grid cs_mb-md cs_gap-md">
              <div class="cs_details-tile">
                <h5>Vertical Oscillation</h5>
                <div class="cs_details-wrapper single-in-row">
                  <div class="cs_details-img">
                    <img src="../../../../assets/img/assessment/vertical-oscillation-icon.png"
                         alt="" />
                  </div>
                  <div class="cs_details-content">
                    <div class="cs_details-item">{{analysis.verticalOscillation.value  | number:'1.0-0'}} cm</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.verticalOscillation.score | enumString: categoryScoreEnum | lowercase }}">{{ overrideScore(analysis.verticalOscillation.score | enumString: categoryScoreEnum )}}</div>
                    </div>
                    <div class="cs_details-item"></div>
                  </div>
                </div>
                <h6>Amount of up-and-down movement while running</h6>
              </div>
            </div>


            <!-- COLLAPSER -->
            <div *ngIf="category == impairmentCategory.Collapser" class="cs_grid cs_mb-md cs_gap-md">
              <div class="cs_details-tile">
                <h5>Peak Contralateral Pelvic Drop</h5>
                <div class="cs_details-wrapper">
                  <div class="cs_details-img">
                    <img src="../../../../assets/img/assessment/cpd-icon.png"
                         alt="" />
                  </div>
                  <div class="cs_details-content">
                    <div class="cs_details-item">R {{removeNegtiveSign(analysis.peakCPD.rightValue) | number:'1.0-0'}}° {{getLabelPelvicDrop(analysis.peakCPD.rightValue, false)}}</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.peakCPD.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakCPD.rightScore | enumString: categoryScoreEnum )}}</div>
                    </div>
                    <div class="cs_details-item">L {{removeNegtiveSign(analysis.peakCPD.leftValue)| number:'1.0-0'}}° {{getLabelPelvicDrop(analysis.peakCPD.leftValue, true)}}</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.peakCPD.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakCPD.leftScore | enumString: categoryScoreEnum )}}</div>
                    </div>
                  </div>
                </div>
                <h6>Amount the opposite hip drops while on the ground</h6>
              </div>

              <div class="cs_details-tile">
                <h5>Peak Hip Adduction</h5>
                <div class="cs_details-wrapper">
                  <div class="cs_details-img">
                    <img src="../../../../assets/img/assessment/peak-hip-adduction-icon.png"
                         alt="" />
                  </div>
                  <div class="cs_details-content">
                    <div class="cs_details-item">R {{removeNegtiveSign(analysis.peakHipAdduction.rightValue)| number:'1.0-0'}}° {{getLabelHipAdduction(analysis.peakHipAdduction.rightValue)}}</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.peakHipAdduction.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakHipAdduction.rightScore | enumString: categoryScoreEnum )}}</div>
                    </div>
                    <div class="cs_details-item">L {{removeNegtiveSign(analysis.peakHipAdduction.leftValue)| number:'1.0-0'}}° {{getLabelHipAdduction(analysis.peakHipAdduction.leftValue)}}</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.peakHipAdduction.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakHipAdduction.leftScore | enumString: categoryScoreEnum) }}</div>
                    </div>
                  </div>
                </div>
                <h6>Inward movement of the thigh toward the midline</h6>
              </div>
            </div>



            <!-- Glute Amnesiac -->
            <div *ngIf="category == impairmentCategory.GluteAmnesiac" class="cs_grid cs_mb-md cs_gap-md">
              <div class="cs_details-tile">
                <h5>Forward Lean</h5>
                <div class="cs_details-wrapper">
                  <div class="cs_details-img">
                    <img src="../../../../assets/img/assessment/forward-lean-icon.png"
                         alt="" />
                  </div>
                  <div class="cs_details-content">
                    <div class="cs_details-item">{{removeNegtiveSign(analysis.forwardLean.value)| number:'1.0-0'}}° {{getLabelForwardLean(analysis.forwardLean.value)}}</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.forwardLean.score | enumString: categoryScoreEnum | lowercase }}">{{ overrideScore(analysis.forwardLean.score | enumString: categoryScoreEnum )}}</div>
                    </div>
                    <div class="cs_details-item"></div>
                  </div>
                </div>
                <h6>Angle of your body's lean while running</h6>
              </div>
            </div>

            <div class="cs_score_description cs_mb-0">
              <div class="cs_score_container">
                <div class="cs_score s-g">e</div>
                Excellent
              </div>

              <div class="cs_score_container">
                <div class="cs_score s-gf">g</div>
                Good
              </div>

              <div class="cs_score_container">
                <div class="cs_score s-f">f</div>
                Fair
              </div>
              <div class="cs_score_container">
                <div class="cs_score s-p">p</div>
                Poor
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


